import { SetNewPasswordTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const SetNewPasswordTrackingSchema: Record<
  SetNewPasswordTrackingPoint,
  string
> = {
  [SetNewPasswordTrackingPoint.PageView]:
    '816060c5-0d4b-4bff-b59c-8c98093ab004',
  [SetNewPasswordTrackingPoint.OkButtonClick]:
    '3a4cdb53-1398-4ec4-9138-7e457a634e15',
  [SetNewPasswordTrackingPoint.BackButtonClick]:
    '5be54ac8-2a16-4e08-b2c5-6ef38a7f7c9f',
  [SetNewPasswordTrackingPoint.HelpButtonClick]:
    'd280b9ad-52a0-4ca6-944e-812fdfaca3c3',
  [SetNewPasswordTrackingPoint.SetPasswordSuccessAction]:
    'b738b75d-eb38-4b30-91bb-e8a247d36f4d',
  [SetNewPasswordTrackingPoint.SetPasswordFailAction]:
    'badee710-d598-4d20-be7d-59c048d012e9',
};

export const getSetNewPasswordPageTypeAndSchema = (
  trackingPoint: SetNewPasswordTrackingPoint
) => {
  return {
    page_type: PageType.SetNewPasswordPage,
    schema: SetNewPasswordTrackingSchema[trackingPoint],
  };
};
